/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CommsEmail/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddEmail from './AddEmail/index'
import Emails from './Emails/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CommsEmail({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="CommsEmail.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-Z1e5bcU': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-2-Z1e5bcU': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="CommsEmail.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="CommsEmail.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Comms Emails"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Add emails and assign default email to send comms to patients."
/>
</div>
<AddEmail
  viewPath={`${viewPath}/AddEmail`}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginTop={dtSpaceS}
 marginBottom={dtSpaceM}
 backgroundColor={dtColorsNeutral200}
/>
<div
  data-testid="CommsEmail.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="CommsEmail.Vertical:3"
  data-view-path={viewPath}
 style={{'--pt-2-Z1e5bcU': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical2}`}
>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}